import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=55fbd5b7&scoped=true"
import script from "./viewImage.vue?vue&type=script&lang=ts"
export * from "./viewImage.vue?vue&type=script&lang=ts"
import style0 from "./viewImage.vue?vue&type=style&index=0&id=55fbd5b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fbd5b7",
  null
  
)

export default component.exports